import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number", 
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};

const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};

const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class GoogleBusinessModuleAttributeFactory {
    /**
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.reviewReceived()
        );
    }

    reviewReceived() {
        const e = AutomationEventTypes.GOOGLE_BUSINESS.REVIEW_RECEIVED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Google Business Review Received", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}._id`, "Review Record ID", vt.STRING),
                ga(context, `${prefix}.reviewId`, "Review ID", vt.STRING),
                ga(context, `${prefix}.locationId`, "Location ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Channel ID", vt.STRING),
                ga(context, `${prefix}.reviewer`, "Reviewer Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.reviewer.displayName`, "Reviewer Name", vt.STRING),
                    ga(context, `${prefix}.reviewer.profilePhotoUrl`, "Profile Photo URL", vt.STRING),
                ]),
                ga(context, `${prefix}.starRating`, "Star Rating", vt.STRING),
                ga(context, `${prefix}.comment`, "Comment", vt.STRING),
                ga(context, `${prefix}.createTime`, "Create Time", vt.DATETIME),
                ga(context, `${prefix}.updateTime`, "Update Time", vt.DATETIME),
                ga(context, `${prefix}.status`, "Status", vt.STRING),
                ga(context, `${prefix}.reply`, "Reply Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.reply.comment`, "Reply Text", vt.STRING),
                    ga(context, `${prefix}.reply.updateTime`, "Reply Time", vt.DATETIME),
                ]),
                ga(context, `${prefix}.location`, "Location Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.location._id`, "Location Record ID", vt.STRING),
                    ga(context, `${prefix}.location.locationId`, "Location ID", vt.STRING),
                    ga(context, `${prefix}.location.title`, "Location Title", vt.STRING),
                    ga(context, `${prefix}.location.address`, "Location Address", vt.STRING),
                    ga(context, `${prefix}.location.phoneNumber`, "Phone Number", vt.STRING),
                    ga(context, `${prefix}.location.websiteUri`, "Website URL", vt.STRING),
                ]),
            ])
        ];
    }
}

export default GoogleBusinessModuleAttributeFactory;
